import { FieldValues, FormProvider } from 'react-hook-form';
import { Dialog } from '@mui/material';
import DetailsPopUpContent from 'shared/components/details-pop-up-content/details-pop-up-content';

import { useConnectorsContextProvider } from 'features/connectors/context/connectors-provider';
import { CLIENT_SECRET_PLACEHOLDER } from 'features/connectors/domain/client-secret-placeholder';
import { Connector, ConnectorType } from 'features/connectors/domain/connector';
import ConnectorDetailsPopupHeader from './connector-details-popup-header';
import ConnectorInformation from './connector-information.component';
import ConnectorSettings from './connector-settings/connector-settings';

const ConnectorDetailsPopup = () => {
  const { connectorDetailsHook } = useConnectorsContextProvider();
  const { currentSelectedConnector, editConnector, addConnector, isDetailsOpen, closeDetails, form } = connectorDetailsHook;

  const updateConnector = (fieldValues: FieldValues) => {
    const connector: Connector = {
      id: currentSelectedConnector?.id,
      name: fieldValues.name ?? '',
      type: currentSelectedConnector?.type ?? ConnectorType.Unknown,
      note: fieldValues.note?.trim(),
      organisationUnits: fieldValues.organisationUnits ?? [],
      vcareConnectorData:
        currentSelectedConnector?.type === ConnectorType.Vcare
          ? {
              organisationId: fieldValues.vcareConnectorData?.organisationId ?? '',
              clientId: fieldValues.vcareConnectorData?.clientId ?? '',
              clientSecret:
                fieldValues.vcareConnectorData?.clientSecret === CLIENT_SECRET_PLACEHOLDER
                  ? undefined
                  : (fieldValues.vcareConnectorData?.clientSecret ?? ''),
            }
          : undefined,
    };
    editConnector(connector);
  };

  const submitForm = (fieldValues: FieldValues) => {
    if (currentSelectedConnector && connectorDetailsHook.viewingMode === 'editing') {
      updateConnector(fieldValues);
    } else {
      addConnector(fieldValues);
    }
  };

  const popUpStyle = {
    style: {
      height: '960px',
      width: '1227px',
      maxWidth: '1227px',
      paddingBottom: '0px',
    },
  };

  return (
    <Dialog
      open={isDetailsOpen}
      onClose={() => closeDetails(form.formState.isDirty)}
      slotProps={{
        paper: popUpStyle,
      }}
    >
      <FormProvider {...form}>
        <DetailsPopUpContent
          onSubmit={form.handleSubmit(submitForm)}
          header={<ConnectorDetailsPopupHeader />}
          leftContent={<ConnectorInformation />}
          rightContent={<ConnectorSettings />}
        />
      </FormProvider>
    </Dialog>
  );
};

export default ConnectorDetailsPopup;
